import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M16.83 9.158a5 5 0 0 0-1.033-.103q-.204-.001-.4.02c-.473-3.4-3.404-6.01-6.957-6.01-3.889 0-7.033 3.127-7.033 6.994s3.144 6.993 7.033 6.993c.892 0 1.744-.164 2.525-.47.199.438.46.843.771 1.204a8.4 8.4 0 0 1-3.296.665c-4.658 0-8.44-3.76-8.44-8.392s3.782-8.392 8.44-8.392c4.353 0 7.94 3.282 8.39 7.491"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M9.011 4.826v5.546c0 .329-.256.575-.579.575h-4.32a.564.564 0 0 1-.579-.575c0-.321.249-.568.58-.568H7.86V4.826a.56.56 0 0 1 .571-.568c.323 0 .58.247.58.568M20 14.362c0 2.287-1.92 4.18-4.203 4.18-2.3 0-4.204-1.876-4.204-4.18 0-2.287 1.903-4.18 4.204-4.18 2.308 0 4.203 1.884 4.203 4.18m-2.706-1.851-2.019 2.78-1.018-1.094a.53.53 0 0 0-.397-.172.51.51 0 0 0-.513.518c0 .115.042.263.133.37l1.406 1.53a.59.59 0 0 0 .414.173c.182 0 .348-.074.43-.197l2.408-3.316a.6.6 0 0 0 .116-.312.52.52 0 0 0-.521-.51c-.19 0-.34.09-.439.23"
    }, null, -1)
  ])))
}
export default { render: render }